"use client";

import { useMemo } from "react";
import { Button } from "@/components/fun-ui/Button";
import { UploadPlugin, UploadPluginRenderProps } from "./plugin-interface";
import { getUploadMessages } from "../locales/messages";

const messages = getUploadMessages();

const LocalFilePluginTrigger = ({ config, disabled, fileInputRef }: UploadPluginRenderProps) => {
  const acceptAttr = useMemo(
    () =>
      config.formats
        .map((format) => [format.accept, ...format.extensions])
        .flat()
        .join(","),
    [config.formats]
  );

  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    // 阻止事件冒泡，避免触发 LocalUploadArea 的点击
    event.stopPropagation();
    event.preventDefault();

    const input = fileInputRef?.current;
    if (disabled || !input) return;
    input.removeAttribute("webkitdirectory");
    input.setAttribute("accept", acceptAttr);
    input.click();
  };

  return (
    <Button
      type="button"
      variant="default"
      onClick={handleButtonClick}
      disabled={disabled}
      className="min-w-[130px]"
    >
      {messages.buttons.uploadByFile}
    </Button>
  );
};

export const localFilePlugin: UploadPlugin = {
  id: "local-file",
  name: messages.buttons.uploadByFile,
  source: "local-file",
  renderTrigger: (props) => <LocalFilePluginTrigger {...props} />,
};

